module.exports = __webpack_public_path__ + "cottage-garden.jpg?0fc26e0c42e08922e83a4bb7048a61d9";


//////////////////
// WEBPACK FOOTER
// ./src/images/cottage-garden.jpg
// module id = 54
// module chunks = 0